"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Discount_service_1 = __importDefault(require("@CommonFrontendBackend/Discount/Discount.service"));
var UniqueId_1 = __importDefault(require("@CommonFrontendBackend/Utils/UniqueId"));
var BillingScheduleOrchestrator_1 = require("QuoteV2/BillingSchedule/BillingScheduleOrchestrator");
var CalculatorService_1 = __importDefault(require("QuoteV2/Calculator/CalculatorService"));
var Quote_1 = __importDefault(require("QuoteV2/Components/Quote"));
var QuoteComponents_1 = require("QuoteV2/Components/QuoteComponents");
var QuoteLabelStore_1 = __importDefault(require("QuoteV2/Labels/QuoteLabelStore"));
var QuoteBlockStore_1 = __importDefault(require("QuoteV2/Stores/QuoteBlockStore"));
var VariableStore_1 = __importDefault(require("QuoteV2/Stores/VariableStore"));
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var VariableService_1 = __importDefault(require("QuoteV2/Variables/VariableService"));
var react_1 = __importStar(require("react"));
var AngularSyncStore_1 = require("Utils/AngularSyncStore");
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var hydrationHelpers_1 = require("../hydrationHelpers");
var Description_1 = __importDefault(require("./Description"));
var ItemQuantity_1 = __importDefault(require("./ItemQuantity"));
var ItemRate_1 = __importDefault(require("./ItemRate"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var Telemetry_1 = require("Public/Telemetry/Telemetry");
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var DIProvider_1 = __importStar(require("DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var TaxService_1 = __importDefault(require("QuoteV2/TaxService"));
var Sentry = __importStar(require("@sentry/browser"));
var QuoteAdapter = require("QuoteV2/Adapter/Adapter");
var QuoteV2 = function (_a) {
    var e_1, _b, e_2, _c;
    var block = _a.block, di = _a.di, $scope = _a.$scope, crmInfo = _a.crmInfo;
    var isAngularAvailable = !!$scope;
    try {
        for (var _d = __values(block.sections), _e = _d.next(); !_e.done; _e = _d.next()) {
            var section = _e.value;
            section.$id = (0, UniqueId_1.default)();
            try {
                for (var _f = (e_2 = void 0, __values(section.items)), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var item = _g.value;
                    item.$id = (0, UniqueId_1.default)();
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var accountQuoteSettings = di.get("accountQuoteSettings");
    var variableService = new VariableService_1.default(accountQuoteSettings, UniqueId_1.default);
    var discountService = new Discount_service_1.default(accountQuoteSettings);
    var quoteCalculatorSettings = di.get("quoteCalculatorSettings");
    var maker = function (constructor, extraArgs) {
        if (extraArgs === void 0) { extraArgs = {}; }
        return function (make) { return make(constructor, extraArgs); };
    };
    var childScope = di.child();
    childScope.load({
        block: block,
        quoteCurrencyFormatter: maker(QuoteCurrencyFormatter_1.default),
        discountService: maker(Discount_service_1.default),
        variableService: maker(VariableService_1.default),
        billingScheduleOrchestrator: maker(BillingScheduleOrchestrator_1.BillingScheduleOrchestrator),
        uniqueId: function () { return UniqueId_1.default; },
    });
    (0, react_1.useEffect)(function () {
        if (isAngularAvailable) {
            var quoteBlocksList_1 = di.get("quoteBlocksList");
            quoteBlocksList_1.add(block);
            var quoteAdapter_1 = new QuoteAdapter(block, accountQuoteSettings, variableService, discountService, {}, undefined, quoteCalculatorSettings);
            quoteBlocksList_1.addAdapter(quoteAdapter_1);
            return function () {
                quoteBlocksList_1.remove(block);
                quoteBlocksList_1.removeAdapter(quoteAdapter_1);
                Sentry.captureException(new Error("QuoteV2.tsx teardown was run"));
            };
        }
    }, []);
    return (react_1.default.createElement(DIProvider_1.RootDIProvider, { di: childScope },
        react_1.default.createElement(DIProvider_1.default, { container: function () {
                var container = new inversify_1.Container({ skipBaseClassChecks: true });
                container.bind(TaxService_1.default).toConstantValue(new TaxService_1.default(accountQuoteSettings.taxes));
                container
                    .bind(AngularSyncStore_1.AngularSyncServices.$)
                    .toConstantValue(isAngularAvailable ? { $scope: $scope, $timeout: di.get("$timeout") } : { disableSync: true });
                container.bind(QuoteBlockStore_1.default).toSelf().inSingletonScope();
                container.bind(CalculatorService_1.default).toSelf().inSingletonScope();
                container.bind(QuoteViewStore_1.QuoteViewStore.$).to(QuoteViewStore_1.PublicQuoteViewStore).inSingletonScope();
                container
                    .bind(QuoteTelemetry_1.QuoteTelemetry)
                    .toConstantValue(new QuoteTelemetry_1.QuoteTelemetry(Telemetry_1.Telemetry.getInstance().track, Telemetry_1.Telemetry.getInstance().debouncedTrack, TelemetryEnums_1.TelemetryContext.Public, new BillingScheduleOrchestrator_1.BillingScheduleOrchestrator()));
                container.bind(VariableStore_1.default).toSelf().inSingletonScope();
                container.bind(QuoteLabelStore_1.default).toSelf().inSingletonScope();
                container.bind(QuoteComponents_1.QuoteComponents.$).toConstantValue({
                    SectionDescription: Description_1.default,
                    TableItemDescription: Description_1.default,
                    PlanCardDescription: Description_1.default,
                    PlanCardFeatureList: Description_1.default,
                    ItemRate: ItemRate_1.default,
                    ItemQuantity: ItemQuantity_1.default,
                    DragDropHandler: function (_a) {
                        var children = _a.children;
                        return (react_1.default.createElement(react_1.default.Fragment, null, children({ dragHandlers: {}, indicatorPosition: undefined, isDraggingProductListToken: undefined })));
                    },
                });
                return container;
            } },
            react_1.default.createElement(Quote_1.default, { className: "qwilr-quote-v2-react" }))));
};
exports.default = (0, hydrationHelpers_1.withHydrationHost)(QuoteV2, { componentName: "QuoteV2" });
